import $ from 'jquery'
import InfoClinique from '@/views/parametres/configs/info-clinique'
import ParamDevise from '@/views/parametres/configs/param-devise'
import ParamCoupureBilletage from '@/views/parametres/configs/param-coupure-billetage'
import ParamBon from '@/views/parametres/configs/param-bon-consultations'
import ParamGestionCoupon from '@/views/parametres/configs/param-autorisation-coupons'
import ParamDHIS2 from '@/views/parametres/configs/param-dhis2'
import ParamSFE from '@/views/parametres/configs/param-sfe'
import ParamAccordionSection from '@/components/param-accordion-section'
import CommissionsPrescripteurs from '@/views/parametres/prescripteurs/activation.vue'
import PaymentMethodsSettings from '@/views/parametres/configs/payment-methods'
import UnitesSoins from '@/views/parametres/unites-soins'
import VaccinationSettings from '@/components/vaccination/Configuration'

export default {
    name: 'etablissement',
    components: {
        InfoClinique, ParamDevise, ParamCoupureBilletage, ParamBon, ParamGestionCoupon,
        ParamDHIS2, ParamSFE, ParamAccordionSection, CommissionsPrescripteurs, PaymentMethodsSettings, UnitesSoins, VaccinationSettings
    },
    props: [],
    data() {
        return {}
    },
    computed: {
        activeRole() {
            return this.$store.getters['activeRole'];
        },
        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },
    mounted() {
        setTimeout(() => {
            $('.show-on-fixed').fadeIn();
        }, 500);
    },
    methods: {}
}
